import { useRouter } from 'next/router';
import { useSize } from '@zapier/identity-utils';
import { paramToBoolean } from '../../../utils';
import { useInvitation, LoginWithSAMLSSOForm } from '@zapier/authentication';
import {
  AuthLayout,
  CompaniesIntroPromo,
  InvitationError,
  InvitationTitle,
} from '../../global';

export function LoginWithSAMLSSOPage() {
  const router = useRouter();
  const size = useSize();

  const invitationCode = router.query.invitation as string | undefined;
  const isReauth = paramToBoolean(router.query.reauth);
  const { next: nextQuery } = router.query;
  const next = Array.isArray(nextQuery) ? nextQuery[0] : nextQuery;

  const invitation = useInvitation(invitationCode);

  if (!invitation.isValid) {
    return <InvitationError error={invitation?.error} url={router.asPath} />;
  }

  const showTitleOnRight = !isReauth && !invitation?.invitation;
  const title = isReauth ? (
    "Let's make sure it's you"
  ) : invitation?.invitation ? (
    <InvitationTitle invitation={invitation.invitation} />
  ) : (
    'Log in with your Identity Provider'
  );

  const showPromo = !isReauth && size !== 'small';

  return (
    <AuthLayout
      promo={<CompaniesIntroPromo />}
      showPromo={showPromo}
      title={title}
      titlePosition={showTitleOnRight ? 'right' : 'center'}
    >
      <LoginWithSAMLSSOForm
        defaultEmail={router.query.email as string | undefined}
        next={next}
        queryParams={router.query}
        invitation={invitation?.isValid ? invitation.invitation : null}
      />
    </AuthLayout>
  );
}
